import PropTypes from 'prop-types';

import {copyableProperty} from '../common';

/**
 * Display value for Category (for sr event)
 */
export const category = (event) => copyableProperty(
    {
        data: event,
        srWithMatchID: ['match', 'tournament', 'tournament_category'],
        srWithoutMatchID: ['tournament', 'tournament_category'],
    },
    'Category'
);

category.propTypes = {
    event: PropTypes.object.isRequired,
};
